import { render, staticRenderFns } from "./Narrative.vue?vue&type=template&id=901311f8&scoped=true&"
import script from "./Narrative.vue?vue&type=script&lang=js&"
export * from "./Narrative.vue?vue&type=script&lang=js&"
import style0 from "./Narrative.vue?vue&type=style&index=0&id=901311f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901311f8",
  null
  
)

export default component.exports